// Purchase model
import purchase_line from "./ModelPurchaseLine";
import tools from "tools/common";
import { getStorage } from "store/local";

const dateTo = tools.dateToday();
const dateFrom = tools.dateAdd(new Date(), "days", -130);

const stateColors = {
  quotation: "slate",
  approved: "sky",
  confirmed: "pink",
  processing: "emerald",
  done: "lime",
};

const getFilters = () => {
  const session = getStorage("ctxSession");
  return {
    all: [
      ["purchase_date", "<=", `${dateTo}`],
      ["purchase_date", ">=", `${dateFrom}`],
      [
        "state",
        "in",
        [
          "quotation",
          "confirmed",
          "processing",
          "approved",
          "canceled",
          "done",
        ],
      ],
      [
        "OR",
        [
          ["confirm_user.user", "=", session.user],
          [
            "state",
            "in",
            [
              "quotation",
              "confirmed",
              "processing",
              "approved",
              "canceled",
              "done",
            ],
          ],
        ],
        [
          ["approval_user.user", "=", session.user],
          [
            "state",
            "in",
            [
              "quotation",
              "confirmed",
              "processing",
              "approved",
              "canceled",
              "done",
            ],
          ],
        ],
        [
          ["authorized_user.user", "=", session.user],
          [
            "state",
            "in",
            ["quotation", "processing", "approved", "confirmed", "done"],
          ],
        ],
      ],
    ],
    pending: [
      [
        "OR",
        [
          ["confirm_user.user", "=", session.user],
          ["state", "=", "quotation"],
          ["approval_user", "=", null],
        ],
        [
          ["approval_user.user", "=", session.user],
          ["authorized_user", "=", null],
          ["state", "in", ["quotation"]],
        ],
        [
          ["approval_user.user", "=", session.user],
          ["authorized_user", "!=", null],
          ["authorized_date", "!=", null],
          ["state", "in", ["quotation"]],
        ],
        [
          ["confirm_user.user", "=", session.user],
          ["state", "=", "approved"],
        ],
        [
          ["authorized_user.user", "=", session.user],
          ["state", "=", "quotation"],
          ["authorized_date", "=", null],
        ],
      ],
    ],
  };
};

function getVisibleSignature(fieldName, rec) {
  console.log("prueba ......", fieldName, rec);
  if (["approval_signature", "approval_date"].includes(fieldName)) {
    return !!rec.approval_user;
  }
  if (["authorized_signature", "authorized_date"].includes(fieldName)) {
    return !!rec.authorized_user;
  }
  return false;
}

const getVisible = (button, rec) => {
  const session = getStorage("ctxSession");
  if (button === "approval") {
    if (
      rec &&
      rec.state === "quotation" &&
      rec.approval_user &&
      rec.approval_user.user === session.user
    ) {
      if (rec.authorized_user && !rec.authorized_date) return false;
      return true;
    }
  } else if (button === "authorize") {
    if (
      rec?.authorized_user &&
      rec.authorized_user.user === session.user &&
      rec.state === "quotation" &&
      !rec.authorized_date
    ) {
      return true;
    }
  } else if (
    rec?.confirm_user &&
    rec.confirm_user &&
    rec.confirm_user.user === session.user
  ) {
    if (
      rec.state === "approved" ||
      (rec.state === "quotation" && !rec.approval_user && !rec.authorized_user)
    ) {
      return true;
    }
  }
  return false;
};

const getView = (config) => {
  Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
  };
  const DictCtxView = {
    limit: 150,
    activeSearch: true,
    form_action: ["attachment"], // options: ['save', 'delete']
    table_action: ["open"], // options: ['open', 'delete', 'edit', 'add']
    title: { field: "number", model: true },
    filters: getFilters,
    validate_state: true, // ??? What is this?
    model: "purchase.purchase",
    tags: {
      state: stateColors,
    },
    webfields: {
      purchase_date: {
        type: "date",
        readOnly: true,
        searchable: true,
      },
      create_uid: {
        type: "many2one",
        model: "res.user",
        readOnly: true,
      },
      company: {
        type: "many2one",
        model: "company.company",
      },
      party: {
        type: "many2one",
        model: "party.party",
        readOnly: true,
        searchable: true,
      },
      warehouse: {
        type: "many2one",
        model: "stock.location",
        readOnly: true,
      },
      invoice_address: {
        type: "many2one",
        model: "party.address",
        readOnly: false,
      },
      payment_term: {
        type: "many2one",
        model: "account.invoice.payment_term",
        readOnly: true,
      },
      approval_user: {
        type: "many2one",
        model: "purchase.configuration.user_authorized",
        readOnly: true,
        fieldsNames: ["user"],
      },
      confirm_user: {
        type: "many2one",
        model: "purchase.configuration.user_authorized",
        readOnly: true,
        fieldsNames: ["user"],
      },
      authorized_user: {
        type: "many2one",
        model: "purchase.configuration.user_authorized",
        readOnly: true,
        fieldsNames: ["user"],
      },
      description: { type: "char", readOnly: true },
      reference: { type: "char", readOnly: true },
      number: { type: "char", readOnly: true, searchable: true },
      confirmation_signature: {
        type: "image",
        readOnly: true,
        bytes: true,
        visible: getVisibleSignature,
      },
      approval_signature: {
        type: "image",
        readOnly: true,
        bytes: true,
        visible: getVisibleSignature,
      },
      authorized_signature: {
        type: "image",
        readOnly: true,
        bytes: true,
        visible: getVisibleSignature,
      },
      project: {
        type: "many2one",
        model: "project.work",
        readOnly: true,
        searchable: true,
      },
      lines: {
        type: "one2many",
        model: "purchase.line",
        ctxView: purchase_line.ctxView(config),
      },
      untaxed_amount: { type: "numeric", readOnly: true },
      tax_amount: { type: "numeric", readOnly: true },
      total_amount: { type: "numeric", readOnly: true },
      comment: {
        type: "text",
        readOnly: {
          state: ["done", "confirmed", "cancelled", "processing"],
        },
      },
      approval_date: {
        type: "char",
        readOnly: true,
        visible: getVisibleSignature,
      },
      authorized_date: {
        type: "char",
        readOnly: true,
        visible: getVisibleSignature,
      },
      approval: {
        type: "button",
        button_method: "approval",
        visible: getVisible,
        onSuccessMsg: "ORDEN DE COMPRA APROBADA!",
        color: "blue",
      },
      confirm: {
        type: "button",
        button_method: "confirm",
        visible: getVisible,
        onSuccessMsg: "ORDEN DE COMPRA CONFIRMADA!",
        color: "pink",
      },
      authorize: {
        type: "button",
        button_method: "authorize",
        visible: getVisible,
        onSuccessMsg: "ORDEN DE COMPRA AUTORIZADA!",
        color: "blue",
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      priority: {
        type: "char",
        translate: true,
      },
    },
    webtree: [
      { name: "number", width: "10%" },
      { name: "purchase_date", width: "10%" },
      { name: "party", width: "25%" },
      { name: "reference", width: "20%" },
      // { name: "project", width: "10%" },
      // { name: "priority", width: "10%" },
      { name: "total_amount", width: "15%" },
      { name: "state", width: "10%", widget: "circle" },
    ],
    webform: [
      { name: "party" },
      { name: "purchase_date" },
      { name: "create_uid" },
      { name: "description" },
      { name: "project" },
      { name: "payment_term" },
      { name: "reference" },
      { name: "authorized_user" },
      { name: "approval_user" },
      { name: "confirm_user" },
      { name: "lines" },
      { name: "untaxed_amount" },
      { name: "tax_amount" },
      { name: "total_amount" },
      { name: "state" },
      { name: "comment" },
      { name: "authorized_signature" },
      { name: "authorized_date" },
      { name: "approval_signature" },
      { name: "approval_date" },
      { name: "confirmation_signature" },
      { name: "authorize" },
      { name: "approval" },
      { name: "confirm" },
    ],
  };

  if (config?.project) {
    DictCtxView.webform.insert(5, { name: "project" });
  }

  return DictCtxView;
};

export default { ctxView: getView };
